import { render, staticRenderFns } from "./PageOverviewDescription.vue?vue&type=template&id=70ce12a7&"
import script from "./PageOverviewDescription.vue?vue&type=script&lang=ts&"
export * from "./PageOverviewDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports